// extracted by mini-css-extract-plugin
var _1 = "_table-module__container";
var _2 = "_table-module__is-loading";
var _3 = "_table-module__no-data-found-text";
var _4 = "_table-module__table";
var _5 = "_table-module__table-body-row";
export { _1 as "container", _2 as "is-loading", _3 as "no-data-found-text", _4 as "table", _5 as "table-body-row" }
